const HOME_CATEGORY_SELECTOR = '[data-goodlot-home-categories]';
const MOBILE_QUERY = '(max-width: 749px)';

function initGoodLotHomeCategories(root) {
  if (!root || root.dataset.goodlotHomeCategoriesInitialized === 'true') return;

  const track = root.querySelector('[data-goodlot-home-category-track]');
  const prev = root.querySelector('[data-goodlot-home-category-prev]');
  const next = root.querySelector('[data-goodlot-home-category-next]');
  const arrows = root.querySelector('[data-goodlot-home-category-arrows]');
  const dots = root.querySelector('[data-goodlot-home-category-dots]');
  const fade = root.querySelector('[data-goodlot-home-category-fade]');

  if (!track || !prev || !next || !dots) return;

  root.dataset.goodlotHomeCategoriesInitialized = 'true';

  let rafId = null;

  const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;

  const getMaxScroll = () =>
    Math.max(0, track.scrollWidth - track.clientWidth);

  /*
   * Center the category set only when it genuinely fits in the desktop viewport.
   * Once the collection count grows enough to overflow, it automatically
   * returns to normal left-to-right carousel behavior.
   */
  const updateAlignment = () => {
    if (isMobile()) {
      track.classList.remove('is-centered');
      return;
    }

    // Measure from the normal flex-start state first.
    track.classList.remove('is-centered');

    requestAnimationFrame(() => {
      const fits = track.scrollWidth <= track.clientWidth + 2;
      track.classList.toggle('is-centered', fits);
    });
  };

  const updateControls = () => {
    if (isMobile()) {
      if (arrows) arrows.hidden = true;
      if (fade) fade.style.display = 'none';
      dots.replaceChildren();
      return;
    }

    const maxScroll = getMaxScroll();
    const current = track.scrollLeft;
    const hasOverflow = maxScroll > 2;

    prev.disabled = !hasOverflow || current <= 2;
    next.disabled = !hasOverflow || current >= maxScroll - 2;

    if (arrows) {
      arrows.hidden = !hasOverflow;
    }

    if (fade) {
      fade.style.display =
        hasOverflow && current < maxScroll - 2
          ? 'block'
          : 'none';
    }
  };

  const onScroll = () => {
    if (rafId !== null) return;

    rafId = requestAnimationFrame(() => {
      rafId = null;
      updateControls();
    });
  };

  const getScrollDistance = () => {
    const firstCard = track.querySelector('[data-goodlot-home-category-card]');

    if (!firstCard) {
      return track.clientWidth * 0.75;
    }

    const styles = window.getComputedStyle(track);
    const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;

    // Move roughly five cards at a time so the 0.2-card visual preview remains.
    return (firstCard.offsetWidth + gap) * 5;
  };

  prev.addEventListener('click', () => {
    track.scrollBy({
      left: -getScrollDistance(),
      behavior: 'smooth',
    });
  });

  next.addEventListener('click', () => {
    track.scrollBy({
      left: getScrollDistance(),
      behavior: 'smooth',
    });
  });

  track.addEventListener('scroll', onScroll, { passive: true });

  const refresh = () => {
    updateAlignment();

    requestAnimationFrame(() => {
      updateControls();
    });
  };

  window.addEventListener('resize', refresh, { passive: true });

  refresh();
}

function initAllGoodLotHomeCategories(scope = document) {
  scope.querySelectorAll(HOME_CATEGORY_SELECTOR).forEach((root) => {
    initGoodLotHomeCategories(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => initAllGoodLotHomeCategories(document),
    { once: true }
  );
} else {
  initAllGoodLotHomeCategories(document);
}

document.addEventListener('shopify:section:load', (event) => {
  initAllGoodLotHomeCategories(event.target);
});
